import React from 'react';

import AdUnitWithRoute, { AdUnitProps } from '../google-dfp';

export const ForumCategoryStrip = (props: AdUnitProps) => {
    return (
        <AdUnitWithRoute
            adUnitCode='forum-category-strip'
            sizes={['fluid']}
            sizeMapping={[
                [[0, 0], ['fluid']],
                [[336, 0], ['fluid']],
                [[1024, 0], ['fluid']],
            ]}
            {...props}
        />
    );
};
